// actions
import axios from "axios";

// CUSTOMIZATION ACTIONS
export const SET_MENU = "@customization/SET_MENU";
export const MENU_TOGGLE = "@customization/MENU_TOGGLE";
export const MENU_OPEN = "@customization/MENU_OPEN";
export const SET_FONT_FAMILY = "@customization/SET_FONT_FAMILY";
export const SET_BORDER_RADIUS = "@customization/SET_BORDER_RADIUS";
export const ENABLE_MOCK_DATA = "ENABLE_MOCK_DATA";
export const DISABLE_MOCK_DATA = "DISABLE_MOCK_DATA";

// Action creators for mock data
export const enableMockData = () => ({ type: ENABLE_MOCK_DATA });
export const disableMockData = () => ({ type: DISABLE_MOCK_DATA });

// SOCKET ACTIONS
export const SOCKET_START = "socket/start";
export const SOCKET_STOP = "socket/stop";

// GLOBAL ALERT ACTIONS
export const SET_GLOBAL_ALERT = "SET_GLOBAL_ALERT";
export const CLEAR_GLOBAL_ALERT = "CLEAR_GLOBAL_ALERT";

export const setGlobalAlert = (alert) => ({ type: SET_GLOBAL_ALERT, payload: alert });
export const clearGlobalAlert = () => ({ type: CLEAR_GLOBAL_ALERT });

// METRICS RETRIEVAL ACTIONS
export const SET_BALANCE = "@balance/SET_BALANCE";
export const SET_PORTFOLIO_VALUE = "SET_PORTFOLIO_VALUE";
export const SET_OPEN_POSITIONS_DAY = "SET_OPEN_POSITIONS_DAY";
export const SET_OPEN_POSITIONS_MONTH = "SET_OPEN_POSITIONS_MONTH";
export const SET_CLOSED_POSITIONS_DAY = "SET_CLOSED_POSITIONS_DAY";
export const SET_CLOSED_POSITIONS_MONTH = "SET_CLOSED_POSITIONS_MONTH";
export const SET_UNREALIZED_PROFITS = "SET_UNREALIZED_PROFITS";
export const SET_REALIZED_PROFITS = "SET_REALIZED_PROFITS";

// Action creaters called when socket connection is established or closed
export const socketStart = () => ({ type: SOCKET_START });
export const socketStop = () => ({ type: SOCKET_STOP });

// Action creators called in WebSocket middleware when a message is received from the server
export const setPortfolioValue = (value) => ({ type: SET_PORTFOLIO_VALUE, payload: value });
export const setOpenPositionsDay = (value) => ({ type: SET_OPEN_POSITIONS_DAY, payload: value });
export const setOpenPositionsMonth = (value) => ({
    type: SET_OPEN_POSITIONS_MONTH,
    payload: value,
});
export const setClosedPositionsDay = (value) => ({
    type: SET_CLOSED_POSITIONS_DAY,
    payload: value,
});
export const setClosedPositionsMonth = (value) => ({
    type: SET_CLOSED_POSITIONS_MONTH,
    payload: value,
});
export const setUnrealizedProfits = (value) => ({ type: SET_UNREALIZED_PROFITS, payload: value });
export const setRealizedProfits = (value) => ({ type: SET_REALIZED_PROFITS, payload: value });

// Action creators for discussion page
export const fetchPostsRequest = () => ({ type: "FETCH_POSTS_REQUEST" });
export const fetchPostsSuccess = (posts) => ({ type: "FETCH_POSTS_SUCCESS", payload: { posts } });
export const fetchPostsFailure = (error) => ({ type: "FETCH_POSTS_FAILURE", payload: { error } });
export const setAlert = (alert) => ({ type: "SET_ALERT", payload: { alert } });

export const addPost = (post) => async (dispatch) => {
    const token = sessionStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/posts/create`,
            post,
            config
        );
        dispatch({ type: "ADD_POST", payload: { post: res.data } });
        dispatch(fetchPosts());
        dispatch(setAlert({ open: true, message: res.data.message, severity: "success" }));
    } catch (error) {
        console.log("An error occurred while adding a post:", error);
        dispatch(setAlert({ open: true, message: error.response.data, severity: "error" }));
    }
};

export const addComment = (postId, comment) => async (dispatch) => {
    const token = sessionStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
        const res = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/posts/${postId}/comments`,
            { comment },
            config
        );
        dispatch({ type: "ADD_COMMENT", payload: { postId, comment: res.data } });
        dispatch(fetchPosts());
        dispatch(setAlert({ open: true, message: res.data.message, severity: "success" }));
    } catch (error) {
        console.log("An error occurred while adding a comment:", error);
        dispatch(setAlert({ open: true, message: error.response.data, severity: "error" }));
    }
};

export const fetchPosts = (page) => async (dispatch) => {
    dispatch(fetchPostsRequest());
    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/posts`);
        dispatch(fetchPostsSuccess(res.data));
    } catch (error) {
        dispatch(fetchPostsFailure(error.message));
    }
};

// FETCH BALANCE HTTP REQUEST
export const fetchBalance = () => async (dispatch) => {
    const token = sessionStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
        const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/auth/balance`, config);
        dispatch({ type: SET_BALANCE, balance: res.data.balance });
    } catch (error) {
        // console.log("An error occurred while fetching balance:", error);
    }
};
